export default __webpack_public_path__ + "static/media/about-us.caf31712.png";